import React, { Component } from "react";
import { withStyles } from "@mui/styles";
import styles from "./index.styles";
import QRCode from "qrcode.react";
import noimg from "../assign-prescriptions/images/noimg.png";
import { Box, Grid } from "@mui/material";

export class RetailLabelTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      boxId,
      accountDetails,
      boxDetails,
      connectionType,
      t,
      ProfileNumber,
      orderDetails,
      classes,
    } = this.props;
    let location = {
      picture_url: "",
      name: "",
      address_line_1: "",
      address_line_2: "",
      city: "",
      state: "",
      country: "",
      zip: "",
    };
    let brandingName = "",
      brandingPhone = "";
    let _boxDetails = boxDetails && boxDetails.filter((x) => x.id === boxId)[0];

    const getBranding = boxDetails.find((ele) => ele.id === boxId);
    if (getBranding) {
      const { brandName, brandPhone } = getBranding;
      brandingName = brandName;
      brandingPhone = brandPhone;
    }
    if (connectionType === 0) {
      if (_boxDetails) {
        location.picture_url = _boxDetails.picture_url;
        location.name = _boxDetails.name;
        location.address_line_1 = _boxDetails.address_line_1;
        location.address_line_2 = _boxDetails.address_line_2;
        location.city = _boxDetails.city;
        location.state = _boxDetails.state;
        location.country = _boxDetails.country;
        location.zip = _boxDetails.zip;
      }
    } else {
      if (_boxDetails) {
        location.picture_url = _boxDetails.picture_url;
        location.name = _boxDetails.name;
        location.address_line_1 = _boxDetails.address.address_line_1;
        location.address_line_2 = _boxDetails.address.address_line_2;
        location.city = _boxDetails.address.city;
        location.state = _boxDetails.address.state;
        location.country = _boxDetails.address.country;
        location.zip = _boxDetails.address.zip;
      }
    }
    let _storageCodes = localStorage.getItem("label-codes");
    let codes = {};
    if (_storageCodes) {
      codes = JSON.parse(_storageCodes);
    }
    return (
      <Box component="div" id="printableArea" className={classes.boxDesign}>
        {accountDetails && (
          <Box component="div" className={classes.boxcontainer}>
            <Box component="div" className={classes.boxLogo}>
              {location && (
                <img style={{width:"60px",height:"60px"}} alt="logo" src={["", null, "null", undefined, "undefined"].includes(location.picture_url) ? noimg 
                : location.picture_url} />
              )}
            </Box>
            <Box component="div" className={classes.spacer}></Box>
            <Box component="div" className={classes.boxLogoDesc}>
              {["", null, "null", undefined, "undefined"].includes(
                accountDetails.name
              )
                ? ""
                : accountDetails.name}
              <br />
            </Box>
          </Box>
        )}
        {location && (
          <Box component="div" className={classes.deliveryContainer}>
            <b>{t("Label.DeliverTo")}</b>:<br />
            {["", null, "null", undefined, "undefined"].includes(location.name)
              ? ""
              : location.name}
            <br />
            {["", null, "null", undefined, "undefined"].includes(
              location.address_line_1
            )
              ? ""
              : location.address_line_1.toString().concat(",")}
            {["", null, "null", undefined, "undefined"].includes(
              location.address_line_2
            )
              ? ""
              : location.address_line_2}
            <br />
            {["", null, "null", undefined, "undefined"].includes(location.city)
              ? ""
              : location.city.toString().concat(",")}
            {["", null, "null", undefined, "undefined"].includes(location.state)
              ? ""
              : location.state.toString()}
            {["", null, "null", undefined, "undefined"].includes(
              location.country
            )
              ? ""
              : location.country.toString().concat("-")}
            {["", null, "null", undefined, "undefined"].includes(location.zip)
              ? ""
              : location.zip}
          </Box>
        )}
        <Box component="div" className={classes.prescriptionContainer}>
          <Grid container>
            <Grid item xs={12}>
              <Box component="div" className={classes.qrcodeContainer}>
                {codes && codes.stockCode ? (
                  <label>
                    <QRCode
                      height="70px"
                      width="70px"
                      includeMargin={false}
                      renderAs={"svg"}
                      value={codes && codes.stockCode}
                    />
                    <br />
                    <br />
                  </label>
                ) : (
                  ""
                )}
              </Box>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <Box component="h3" sx={{ textAlign: "left", mb: "4px" }}>
                {codes && codes.stockCode}
              </Box>
            </Grid>
          </Grid>
          <Box component="div" sx={{ borderBottom: "1px solid #000" }}></Box>
          <Grid container sx={{ mt: "5px", mb: "5px" }}>
            <Grid item xs={12}>
              <b>{t("Retail.ProfileId")}</b>: {ProfileNumber}
              <br />
            </Grid>
          </Grid>
          <Box component="div" sx={{ borderBottom: "1px solid #000" }}></Box>
          <Grid container sx={{ mt: "5px", mb: "5px" }}>
            <Grid item xs={12}>
              <b>
                {t("Retail.OrderDetail")}
              </b>
              <br />
              {orderDetails &&
                orderDetails.map((order, index) => {
                  return (
                    <Box component="div" key={index}>
                     {order && order.item}
                    </Box>
                  );
                })}
            </Grid>
          </Grid>
          <Box component="div" sx={{ borderBottom: "1px solid #000" }}></Box>
          <Grid container sx={{ mt: "5px" }}>
            <Grid item xs={12}>
              <Box
                component="div"
                sx={{ fontWeight: "400", fontSize: "0.8rem" }}
              >
                {`${t("Retail.SecMessage")} ${brandingName} at ${brandingPhone}`}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    );
  }
}

export default withStyles(styles)(RetailLabelTemplate);



// WEBPACK FOOTER //
// ./src/components/retail-orders/printTemplate.js